<div class="redirect-container">
  <div class="logo-container">
    @if (logoUrl) {
      <img
        [src]="logoUrl"
        alt="Large Logo"
        class="large-logo"
      />
    } @else {
      <app-loader class="m-auto" minHeight="200"/>
    }
  </div>

  <div>
    <h1 class="message">{{ message }}</h1>
    <p>Thank you for signing</p>
  </div>

  @if (isAuthorized) {
    <a [routerLink]="documentPath" class="btn btn-secondary">
      Go to document
    </a>
  }
</div>
